// `<iproov-me>` fetches nothing until it mounts (after POST /faces), then loads these in
// serial waves before `ready`. Preloading overlaps them with the POST (VEX-8115).
export const IPROOV_SDK_VERSION = "6.2.0";

type PreloadAs = "script" | "style" | "fetch";

/** Must match how iProov requests each file, or the browser downloads it twice. */
export const IPROOV_PRE_READY_ASSETS: ReadonlyArray<{ path: string; as: PreloadAs }> = [
  { path: "chunks/302.js", as: "script" },
  { path: "chunks/vendors.js", as: "script" },
  { path: "chunks/HoldAnalyser.js", as: "script" },
  { path: "css/iProovMe.css", as: "style" },
  { path: "bin/utils_wasm_bg.wasm", as: "fetch" },
  { path: "chunks/926.js", as: "script" },
  { path: "chunks/422.js", as: "script" },
  { path: "chunks/598.js", as: "script" },
  { path: "chunks/154.js", as: "script" },
  { path: "chunks/851.js", as: "script" },
  { path: "chunks/143.js", as: "script" },
];

let preloaded = false;

export function preloadIProovAssets(assetsOrigin: string = window.location.origin): void {
  if (preloaded || typeof document === "undefined") return;
  preloaded = true;

  for (const { path, as } of IPROOV_PRE_READY_ASSETS) {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = as;
    link.href = `${assetsOrigin}/iproov-assets/${IPROOV_SDK_VERSION}/${path}`;
    // fetch() requests are CORS-mode, so their preload must be too.
    if (as === "fetch") link.crossOrigin = "anonymous";
    document.head.appendChild(link);
  }
}
